export default "__VITE_ASSET__176fb7e7__"